import { put, takeLatest } from 'redux-saga/effects'
import { submitChangePassword as submit } from '../api/passwordChange'
import {
  submitChangePasswordSucceeded,
  submitChangePasswordFailed
} from '../../actions/changePassword'
import { SUBMIT_CHANGE_PASSWORD } from '../../constants/action.types'
import executeSaga from './helpers/executeSaga'

export function* submitChangePassword({ request }, action) {
  const { oldPassword, password } = action.payload
  const data = {
    old_password: oldPassword,
    new_password: password
  }

  yield executeSaga(
    request,
    data,
    () => put(submitChangePasswordSucceeded()),
    error => put(submitChangePasswordFailed({ error: error.message }))
  )
}

export default function*({ request } = { request: submit }) {
  yield takeLatest(SUBMIT_CHANGE_PASSWORD, submitChangePassword, { request })
}
